import { FieldOperators } from 'src/interfaces/agent.interface';
import { HumanDetectionResult } from 'src/interfaces/call.interface';

export enum UiConditionType {
  UNSELECTED = 'unselected',
  CALL = 'call',
  POST_CALL_CONTAINS = 'post_call_contains',
  POST_CALL_JSON_PROPERTY = 'post_call_json_property',
  POST_CALL_DATA_EXTRACTION = 'post_call_data_extraction',
}

export enum PostCallConditionsMode {
  PROMPT = 'prompt',
  DATA_EXTRACTION = 'data_extraction',
}

export type UnselectedCondition = {
  id: string;
  type: UiConditionType.UNSELECTED;
};

export type CallCondition = {
  id: string;
  type: UiConditionType.CALL;
  humanDetectionResult: HumanDetectionResult;
};

export type PostCallContainsCondition = {
  id: string;
  type: UiConditionType.POST_CALL_CONTAINS;
  searchString: string;
};

export type PostCallJsonPropertyCondition = {
  id: string;
  type: UiConditionType.POST_CALL_JSON_PROPERTY;
  path: string;
  operator?: FieldOperators; // optional in UI; enforced on save
  value: string;
};

export type PostCallDataExtractionCondition = {
  id: string;
  type: UiConditionType.POST_CALL_DATA_EXTRACTION;
  analysisItemId: string;
  operator?: FieldOperators; // optional in UI; enforced on save
  right: string | boolean | null; // string used for STRING/NUMBER/ENUM, boolean for BOOLEAN
};

export type UiCondition =
  | UnselectedCondition
  | CallCondition
  | PostCallContainsCondition
  | PostCallJsonPropertyCondition
  | PostCallDataExtractionCondition;

export const generateConditionId = () =>
  `condition-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
